<template>
  <b-modal id="updateUserDataFirmModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdatafirm.updateUserDataFirmHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="userdatafirm">
      <b-col>
        <UserDataFirmUpdate :userdatafirmId="userdatafirm['@id']"></UserDataFirmUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UserDataFirmUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateUserDataFirmModal',
  components: {
    UserDataFirmUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdatafirm.update.show
    },
    userDataFirmPivot () {
      return this.$store.state.modals.userdatafirm.update.userDataFirmPivot
    },
    close () {
      return this.$store.state.modals.userdatafirm.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'userDataFirmPivot': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      userdatafirm: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.userDataFirmPivot) {
        this.userdatafirm = Object.assign({}, this.userDataFirmPivot)
        this.$store.state.modals.userdatafirm.update.show = 0
        this.$store.state.modals.userdatafirm.update.userDataFirmPivot = null
        this.$bvModal.show('updateUserDataFirmModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdatafirm.update.close = 0
        this.$bvModal.hide('updateUserDataFirmModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
